'use client';

import { useEffect, useRef } from 'react';

import { dataLayerConfig } from '@/utils';

import type { VWODecisionData } from '@/utils/vwo/types';

export interface VWOExperimentDecision extends VWODecisionData {
	featureFlagKey: string;
}

export interface IVWOExperimentPush {
	/** Experiment decisions from server-side VWO FME resolution */
	decisions: VWOExperimentDecision[];
}

const VWOExperimentPush = ({ decisions }: IVWOExperimentPush) => {
	const pushedRef = useRef(false);

	useEffect(() => {
		if (pushedRef.current || !decisions.length) return;
		pushedRef.current = true;

		for (const decision of decisions) {
			const id = decision.experimentId ?? decision.rolloutId;
			const variationId = decision.experimentVariationId ?? decision.rolloutVariationId;
			const key = decision.experimentKey ?? decision.rolloutKey;

			if (id == null || variationId == null) continue;

			dataLayerConfig({
				event: 'vwo-data-push-ga4',
				vwo_exp_variant_string: `VWO-${id}-${variationId}`,
				vwo_feature_key: decision.featureKey ?? decision.featureFlagKey,
				vwo_experiment_id: id,
				vwo_experiment_key: key,
				vwo_experiment_variation_id: variationId,
			});
		}
	}, [decisions]);

	return null;
};

export default VWOExperimentPush;
